module.exports = __webpack_public_path__ + "media/assets/site_images/team/daniel-7e0dddbc0fef9c2962ca2d6d2fa6b89f.jpg";